#@import Booking.Presenters.Book
#@import Booking.Views.Base
#@export Booking.Views.Book

class Booking.Views.Book extends Booking.Views.Base

  presenter: Booking.Presenters.Book

  templateName: 'book'

  attributes: ->
    'data-bhw': "#{Booking.bhw}BookButton"

  setElement: ->
    Booking.Views.Base::setElement.apply this, arguments
    @$el.attr @attributes()
